import { CartItem } from "@gen/travel/v1/cart_pb";
import { Travel } from "@gen/travel/v1/common_pb";
import { getCart, release, confirm } from "@services/cart";
import { create } from "zustand";

export interface CartStore {
  cart: CartItem[] | undefined;
  isLoading: boolean;
  fetchCart: () => Promise<void>;
  release: (travel: Travel) => Promise<void>;
  confirm: (travel: Travel) => Promise<Travel>;
  clearCart: () => void;
}

export const useCartStore = create<CartStore>((set, get) => ({
  cart: undefined,
  isLoading: false,
  fetchCart: async () => {
    if (get().isLoading) return;
    set({ isLoading: true });
    try {
      const res = await getCart();
      set({ cart: res.items });
    } catch (error) {
      console.error("Error fetching cart:", error);
    } finally {
      set({ isLoading: false });
    }
  },
  release: async (travel: Travel) => {
    try {
      await release(travel);
      set({
        cart: get().cart?.filter((item) => item.travel?.id !== travel.id),
      });
    } catch (error) {
      console.error("Error releasing travel:", error);
      throw error;
    }
  },
  confirm: async (travel: Travel): Promise<Travel> => {
    try {
      const res = await confirm(travel);
      set({
        cart: get().cart?.filter((item) => item.travel?.id !== travel.id),
      });
      if (!res.confirmedTravel) throw new Error("received null travel");
      return res.confirmedTravel;
    } catch (error) {
      console.error("Error confirming travel:", error);
      throw error;
    }
  },
  clearCart: () => set({ cart: undefined }),
}));
